export const NotificationStatus = {
  Received: "received",
};
